/*
 * Copyright (c) 2020. American Express Company
 */

import React, { Component } from 'react';
import Popover from '@mui/material/Popover';

import { GlyphLinkOut } from '@americanexpress/dls-react';
import Typography from '../../components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

import './MoreInfoDialog.scss';
import { ClickAwayListener } from '@mui/material';

export default class MoreInfoDialog extends Component<any> {
    public override render(): JSX.Element {
        let anchorOrigin: any;
        let transformOrigin: any;

        switch (this.props.position) {
            // eslint-disable-next-line default-case-last
            default:
            case 'bottom':
                anchorOrigin = {
                    vertical: 'bottom',
                    horizontal: 'center'
                };
                transformOrigin = {
                    vertical: 'top',
                    horizontal: 'center'
                };
                break;
        }

        const linkDiv =
            this.props.linkName && this.props.link ? (
                <React.Fragment>
                    <Typography variant={TypographyVariants.CAPTION} key="learn" className="link">
                        <a target="_blank" rel="noopener noreferrer" href={this.props.link}>
                            {this.props.linkName}
                        </a>
                        <GlyphLinkOut />
                    </Typography>
                </React.Fragment>
            ) : null;

        const handleClickAway = (): void => {
            this.props.handleClose();
        };

        const mainDiv = (
            <ClickAwayListener onClickAway={handleClickAway}>
                <div key="main-div">
                    {this.props.title ? (
                        <Typography variant={TypographyVariants.SUBTEXT} key="title" className="title">
                            {this.props.title}
                        </Typography>
                    ) : null}
                    <Typography variant={TypographyVariants.CAPTION} key="body" className="body">
                        {this.props.body}
                    </Typography>
                    {linkDiv}
                </div>
            </ClickAwayListener>
        );

        return this.props.x ? (
            <div
                className="more-info-div"
                key="more-info"
                style={{
                    top: this.props.y,
                    left: this.props.x
                }}
            >
                {mainDiv}
            </div>
        ) : (
            <Popover
                id="more-info-dialog"
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
                open={this.props.open}
                PaperProps={{ className: 'paper' }}
                className="more-info-dialog"
                anchorEl={this.props.anchor}
                key="more-info"
            >
                {mainDiv}
            </Popover>
        );
    }
}
